export default "/images/ipaymer-dark.svg?89a9d4cf421d9bcd93c704930afd5cb3";